import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs } from 'vue';
import { Popover as ElPopover } from 'element-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'IMenu',
  props: {
    value: { type: Boolean },
    hasUnderline: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', newVal: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: boolean;
  hasUnderline?: boolean;
};



const attrs: { title?: string; 'aria-label'?: string } = useAttrs();

const isShow = computed({
  get() {
    return props.value;
  },
  set(newVal) {
    emit('input', newVal);
  },
});

return { __sfc: true,props, emit, attrs, isShow, ElPopover }
}

})